import React, { useState } from 'react';

const Step3Crypto = ({ setCurrentStep, onCryptoSelect }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState(null);

   const handleCryptoClick = async (cryptoType, imageSrc, currencyCode) => {
      setIsLoading(true);
      setError(null);

      try {
         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }

         // Llamar a la API para obtener información de depósito
         const response = await fetch(`https://pt-api.digit-a.net/api/deposit/deposit-coin/select-currency/${currencyCode}`, {
            method: 'GET',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            }
         });

         if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
         }

         const data = await response.json();
         console.log('Currency deposit info:', data);

         // Pasar los datos completos al controlador de selección de criptomoneda
         onCryptoSelect({
            name: cryptoType,
            image: imageSrc,
            qrCode: data.qrCode,
            address: data.address,
            currency: data.currency
         });
      } catch (err) {
         console.error('Error fetching deposit information:', err);
         setError(err.message);

         // Aún así pasar información básica en caso de error
         onCryptoSelect({
            name: cryptoType,
            image: imageSrc,
            error: err.message
         });
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <div className="modal_content_body">
         <h3 className="ppt_form_title mb-2 text-center">Select</h3>
         {isLoading && (
            <div className="text-center mb-3">
               <p>Loading deposit information...</p>
            </div>
         )}
         {error && (
            <div className="text-center mb-3 text-danger">
               <p>Error: {error}</p>
               <p>Please try again or contact support.</p>
            </div>
         )}
         <div className='ppt_deposit_ex text-center gap-3'>
            <div className='ppt_deposit_item justify-content-start' style={{ backgroundColor: 'transparent' }}>
               <p>CRYPTO</p>
               <div className='ppt_deposit_item_imgs'>
                  <img
                     src={process.env.PUBLIC_URL + '/assets/img/icon_btc.svg'}
                     alt="Bitcoin"
                     width={'48px'}
                     onClick={() => handleCryptoClick('Bitcoin', '/assets/img/icon_btc.svg', 'BTC')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
                  <img
                     src={process.env.PUBLIC_URL + '/assets/img/icon_eth.svg'}
                     alt="Ethereum"
                     width={'48px'}
                     onClick={() => handleCryptoClick('Ethereum', '/assets/img/icon_eth.svg', 'ETH')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
                  <img
                     src={process.env.PUBLIC_URL + '/assets/img/icon_pol.svg'}
                     alt="Polygon"
                     width={'48px'}
                     onClick={() => handleCryptoClick('Polygon', '/assets/img/icon_pol.svg', 'MATIC')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
               </div>
               <div className='ppt_deposit_item_imgs'>
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_propt_n.svg'}
                     alt="PROPT N"
                     width={'48px'}
                     onClick={() => handleCryptoClick('PROPT N', '/assets/img/icon_propt_n.svg', 'PROPT')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_propt_gold.svg'}
                     alt="PROPT Gold"
                     width={'48px'}
                     onClick={() => handleCryptoClick('PROPT Gold', '/assets/img/icon_propt_gold.svg', 'PROPTG')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_propt_silver.svg'}
                     alt="PROPT Silver"
                     width={'48px'}
                     onClick={() => handleCryptoClick('PROPT Silver', '/assets/img/icon_propt_silver.svg', 'PROPTS')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
               </div>
            </div>
            <span className="hr-v"></span>
            <div className='ppt_deposit_item justify-content-start' style={{ backgroundColor: 'transparent' }}>
               <p>STABLECOIN</p>
               <div className='ppt_deposit_item_imgs'>
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_usdc.svg'}
                     alt="USDC"
                     width={'48px'}
                     onClick={() => handleCryptoClick('USDC', '/assets/img/icon_usdc.svg', 'USDC')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_usdt.svg'}
                     alt="USDT"
                     width={'48px'}
                     onClick={() => handleCryptoClick('USDT', '/assets/img/icon_usdt.svg', 'USDT')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
               </div>
               <div className='ppt_deposit_item_imgs'>
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_propt_euro.svg'}
                     alt="PROPT Euro"
                     width={'48px'}
                     onClick={() => handleCryptoClick('PROPT Euro', '/assets/img/icon_propt_euro.svg', 'PROPTE')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
                  <img
                     disabled
                     src={process.env.PUBLIC_URL + '/assets/img/icon_propt_dollar.svg'}
                     alt="PROPT Dollar"
                     width={'48px'}
                     onClick={() => handleCryptoClick('PROPT Dollar', '/assets/img/icon_propt_dollar.svg', 'PROPTD')}
                     style={{ cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                  />
               </div>
            </div>
         </div>
      </div>
   );
};

export default Step3Crypto;